import { render, staticRenderFns } from "./UkrposhtaTable.vue?vue&type=template&id=116b80b8&scoped=true"
import script from "./UkrposhtaTable.vue?vue&type=script&lang=js"
export * from "./UkrposhtaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116b80b8",
  null
  
)

export default component.exports